import { VariantProps } from 'class-variance-authority';
import { tileContentColor, tileSurface } from '../IconTile/IconTile';
import { Text } from '../Text/Text';

export type DateTileProps = {
  /** Pre-formatted month abbreviation, e.g. "Sep". */
  month: string;
  /** Pre-formatted day of the month, e.g. "1". */
  day: string;
  /** Matches `IconTile`'s intents, defaults to `default`. */
  intent?: NonNullable<VariantProps<typeof tileSurface>['intent']>;
};

/**
 * A 48x48 tile showing a two-line date. Takes pre-formatted strings rather than
 * a `Date`: month abbreviations are locale-dependent, so the formatting belongs
 * in the app's i18n layer.
 */
export const DateTile = ({ month, day, intent = 'default' }: DateTileProps) => {
  return (
    <div
      className={`${tileSurface({ intent, size: null })} ${tileContentColor({ iconColor: intent })} h-l aspect-square flex-col items-center justify-center`}
    >
      <Text as="span" size="label" color="inherit">
        {month}
      </Text>
      <Text as="span" size="labelStrong" color="inherit">
        {day}
      </Text>
    </div>
  );
};
